import { useEffect } from 'react';
import axios from '../utils/axios';

const ThemeController = () => {
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await axios.get('/settings');
                const data = response.data?.data || response.data;
                const primaryColor = data?.themeColors?.primaryColor || '#009B8C';

                // Set CSS variables on root element
                document.documentElement.style.setProperty('--primary-color', primaryColor);
                // Also update legacy variable if exists
                document.documentElement.style.setProperty('--color-primary-hex', primaryColor);
            } catch (error) {
                console.error('Failed to load theme settings:', error);
            }
        };

        fetchSettings();

        // Listen for settings update event (if we trigger it from Admin)
        window.addEventListener('settingsUpdated', fetchSettings);
        return () => window.removeEventListener('settingsUpdated', fetchSettings);
    }, []);

    return null;
};

export default ThemeController;
